<div class="jobs-page">
  <div class="jobs-header">
    <div class="header-left">
      <h1>Jobs</h1>
      <p>
        Showing page {{ pageNumber }} of {{ totalPages || 1 }} 
        (Total {{ totalCount }} jobs)
      </p>
    </div>

    <button type="button" class="create-btn" (click)="onCreateJob()">
      Create Job
    </button>
  </div>

  @if (isLoading) {
    <div class="empty-state">Loading jobs...</div>
  } @else if (errorMessage) {
    <div class="empty-state error">{{ errorMessage }}</div>
  } @else {
    <div class="jobs-table-card">
      <div class="table-scroll">
        <table class="jobs-table">
          <thead>
            <tr>
              @if (isSuperAdmin()) { <th class="expand-th"></th> }
              <th class="col-center">Job ID</th>
              <th>Job Info</th>
              <th class="col-center">Pick Best</th>
              <th class="col-center">Crop</th>
              <th class="col-center">Enhance</th>
              <th class="col-center">Extract BG</th>
              <th class="col-center">Images</th>
              <th>Cost</th>
              <th title="Wallet credits applied to this job.">
                Credit Used
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="info-icon">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd" />
                </svg>
              </th>
              <th title="Remaining amount to be paid by card.">
                To Pay
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="info-icon">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd" />
                </svg>
              </th>
              <th>Status</th>
              <th class="col-center">Active</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            @for (job of jobs; track job.id) {
              <tr [class.row-expanded]="isExpanded(job.id)">
                @if (isSuperAdmin()) {
                  <td class="expand-cell">
                    <button
                      type="button"
                      class="expand-btn"
                      [class.expanded]="isExpanded(job.id)"
                      (click)="toggleExpand(job.id)"
                      title="Toggle sub-jobs"
                    >
                      <svg class="chevron-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                      </svg>
                    </button>
                  </td>
                }
                <td class="job-id col-center">{{ job.id }}</td>
                <td>
                  <div class="job-name">{{ job.name }}</div>
                  <div class="job-subtitle">{{ job.createdAt | date:'mediumDate' }}</div>
                </td>
                <td class="col-center">
                  <span class="status-badge" [class.active]="job.pickBestImage">
                    {{ job.pickBestImage ? 'Yes' : 'No' }}
                  </span>
                </td>
                <td class="col-center">
                  <span class="status-badge" [class.active]="job.cropImages">
                    {{ job.cropImages ? 'Yes' : 'No' }}
                  </span>
                </td>
                <td class="col-center">
                  <span class="status-badge" [class.active]="job.enhanceImages">
                    {{ job.enhanceImages ? 'Yes' : 'No' }}
                  </span>
                </td>
                <td class="col-center">
                  <span class="status-badge" [class.active]="job.extractBackground">
                    {{ job.extractBackground ? 'Yes' : 'No' }}
                  </span>
                </td>
                <td class="images-count col-center">{{ job.noOfImages }}</td>
                <td>
                  <span class="cost-badge">{{ job.completePaidAmount | currency }}</span>
                </td>
                <td>
                  <span class="credit-badge">{{ getSafeAmount(job.creditsUsedAmount) | currency }}</span>
                </td>
                <td>
                  <span class="to-pay-badge" [class.paid]="getSafeAmount(job.amountToPay) === 0" [class.unpaid]="getSafeAmount(job.amountToPay) > 0">
                    {{ getSafeAmount(job.amountToPay) | currency }}
                  </span>
                </td>
                <td>
                  <span class="status-pill status-{{ (job.status || 'draft') | lowercase }}" [class.status-error]="job.canRequeue || (job.status || '').toLowerCase().includes('fail')">{{ getJobStatusDisplay(job.status) }}</span>
                </td>
                <td class="col-center">
                  <span class="status-badge" [class.active]="job.isActive">{{ job.isActive ? 'Yes' : 'No' }}</span>
                </td>
                <td>
                  <div class="action-links">
                    <button type="button" class="link-btn" (click)="onDetail(job)">Detail</button>
                    @if (canShowDownload(job)) {
                      <button
                        type="button"
                        class="link-btn download-btn"
                        [disabled]="downloadingJobId === job.id"
                        (click)="onDownload(job)"
                      >
                        {{ downloadingJobId === job.id ? 'Loading...' : '⬇ Download' }}
                      </button>
                    } @else if (job.canRequeue && job.failedStage) {
                      <button type="button" class="link-btn requeue-btn" [disabled]="isRequeuingId === job.id" (click)="onRequeue(job)">
                        {{ isRequeuingId === job.id ? 'Requeuing...' : 'Requeue' }}
                      </button>
                    }
                  </div>
                </td>
              </tr>
              @if (isSuperAdmin() && isExpanded(job.id)) {
                <tr class="subjobs-row">
                  <td colspan="14">
                    <div class="subjobs-container">
                      @if (subJobsLoadingMap[job.id]) {
                        <div class="subjobs-loading">
                          <span class="subjobs-spinner"></span>
                          Loading sub-jobs...
                        </div>
                      } @else if (subJobsErrorMap[job.id]) {
                        <div class="subjobs-error">
                          <span>{{ subJobsErrorMap[job.id] }}</span>
                          <button type="button" class="subjobs-retry-btn" (click)="fetchSubJobs(job.id)">Retry</button>
                        </div>
                      } @else if ((subJobsMap[job.id] || []).length === 0) {
                        <div class="subjobs-empty">No sub-jobs found for this job.</div>
                      } @else {
                        <table class="subjobs-table" style="border-collapse:collapse;width:100%;">
                          <thead>
                            <tr style="vertical-align:middle;">
                              <th style="vertical-align:middle;">SubJob ID</th>
                              <th style="vertical-align:middle;">Sequence Range</th>
                              <th style="vertical-align:middle;">Image Count</th>
                              <th style="vertical-align:middle;">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (subJob of subJobsMap[job.id]; track subJob.jobSubJobId) {
                              <tr style="vertical-align:middle;">
                                <td class="subjob-id" style="vertical-align:middle;">#{{ subJob.jobSubJobId }}</td>
                                <td class="subjob-seq" style="vertical-align:middle;">{{ subJob.startSequenceNo }} - {{ subJob.endSequenceNo }}</td>
                                <td class="subjob-count" style="vertical-align:middle;">{{ subJob.imageCount }}</td>
                                <td style="vertical-align:middle;"><span class="status-pill status-{{ (subJob.status || '') | lowercase }}">{{ getSubJobStatusDisplay(subJob.status) }}</span></td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      }
                    </div>
                  </td>
                </tr>
              }
            }
            @if (jobs.length === 0) {
              <tr>
                <td colspan="14" style="text-align: center; padding: 24px; color: #64748b;">No jobs found.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="pagination-controls">
        <button 
          type="button" 
          class="btn-pagination" 
          (click)="previousPage()" 
          [disabled]="pageNumber === 1 || isLoading">
          Previous
        </button>
        <span class="page-info">Page {{ pageNumber }} of {{ totalPages || 1 }}</span>
        <button 
          type="button" 
          class="btn-pagination" 
          (click)="nextPage()" 
          [disabled]="pageNumber >= totalPages || isLoading">
          Next
        </button>
      </div>
    </div>
  }

  @if (showSubmitAlert) {
    <div class="modal-overlay" (click)="closeSubmitAlert()">
      <div class="validation-alert-modal" (click)="$event.stopPropagation()" [style.border-top]="submitAlertIsSuccess ? '4px solid #198754' : ''">
        @if (submitAlertIsSuccess) {
          <div class="alert-modal-icon" style="color: #198754;">✅</div>
          <h3>Success</h3>
        } @else {
          <div class="alert-modal-icon">⚠️</div>
          <h3>Alert</h3>
        }
        <p class="alert-error-text">{{ submitMessage }}</p>
        <button type="button" class="alert-ok-btn" (click)="closeSubmitAlert()">Got It</button>
      </div>
    </div>
  }

  @if (showDownloadPaymentDialog && downloadDialogJob && downloadDialogData) {
    <div class="modal-overlay" (click)="closeDownloadPaymentDialog()">
      <div class="download-payment-modal" (click)="$event.stopPropagation()">

        <div class="dpm-header">
          <div class="dpm-lock-icon">🔒</div>
          <h3>Payment Required to Download</h3>
          <p class="dpm-subtitle">Complete the remaining balance to unlock your processed photos.</p>
        </div>

        <div class="dpm-job-name">{{ downloadDialogJob.name }}</div>

        <div class="dpm-amounts">
          <div class="dpm-amount-row paid">
            <div class="dpm-amount-label">
              <span class="dpm-dot paid"></span>
              Advance Paid
            </div>
            <div class="dpm-amount-value paid">{{ downloadAdvancePaid | currency }}</div>
          </div>
          <div class="dpm-divider"></div>
          <div class="dpm-amount-row remaining">
            <div class="dpm-amount-label">
              <span class="dpm-dot remaining"></span>
              Remaining Balance
            </div>
            <div class="dpm-amount-value remaining">{{ downloadDialogData.remainingAmount | currency }}</div>
          </div>
        </div>

        <div class="dpm-actions">
          <button type="button" class="dpm-cancel-btn" (click)="closeDownloadPaymentDialog()">Cancel</button>
          <button type="button" class="dpm-pay-btn" (click)="onPayDownloadNow()">
            💳 Pay Now
          </button>
        </div>

      </div>
    </div>
  }

</div>